import React from 'react';
import { Tabs as BaseTabs, Tab as BaseTab } from '@mui/material';

import TabLabel from './TabLabel';
import { useStyles } from './styles';
import { ITabsProps } from './interfaces';

const Tabs = ({ active, onChange, tabs, sx }: ITabsProps) => {
  const classes = useStyles();

  return (
    <BaseTabs
      value={active}
      onChange={onChange}
      sx={{ ...classes.tabs, ...sx }}
    >
      {tabs.map((tab) => (
        <BaseTab
          key={tab.value}
          label={<TabLabel text={tab.label} />}
          value={tab.value}
          sx={classes.tab}
          disableRipple
        />
      ))}
    </BaseTabs>
  );
};

export default Tabs;
